export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.lnyuanyikj.xyz/app/misi/ms.plist",
  androidUrl: "http://asset.lnyuanyikj.xyz/app/misi/misi.apk",
  apiDomain: "https://www.lnyuanyikj.xyz",
  sharePrefix: "#misi#",
};
